(function () {
  'use strict';

  angular.module('settings.stacking.plan', ['ngResource']);
})();
